import { render, staticRenderFns } from "./ReturnBankList.vue?vue&type=template&id=2aaf514c&"
import script from "./ReturnBankList.vue?vue&type=script&lang=js&"
export * from "./ReturnBankList.vue?vue&type=script&lang=js&"
import style0 from "./ReturnBankList.vue?vue&type=style&index=0&id=2aaf514c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports